import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { isNil } from 'lodash';

import DiscountSign from '../DiscountSign';
import { modelOf } from '../../../prop-types';
import ProductPriceInfo from '../../../models/ProductPriceInfo';
import globalTranslations from '../../../i18n/globalTranslations';
import Price from '../Price';
import ProductSingularPrice from '../ProductSingularPrice';
import ConfigStore from '../../../store/ConfigStore';
import ProductMerchantInfo from '../../../models/ProductMerchantInfo';

@observer
export class ProductPagePrice extends Component {
  renderDiscountDescription = () => {
    const { product } = this.props;
    const discountPercentage = Math.round(
      product.price_info.discount_percentage
    );
    if (discountPercentage >= 40) {
      return (
        <FormattedMessage
          id="product.topDiscount"
          defaultMessage="Top discount"
        />
      );
    } else if (discountPercentage >= 30) {
      return (
        <FormattedMessage
          id="product.superOffer"
          defaultMessage="Super offer"
        />
      );
    } else {
      return (
        <FormattedMessage id="product.nowOnly" defaultMessage="Now only" />
      );
    }
  };

  render() {
    const {
      configStore,
      product,
      price,
      withTax,
      withDiscountLabel,
      withDiscountUpTo,
      withDiscountBalloon,
      withDiscountSavings,
      discountInverted,
      className,
      isSecondaryPrice,
      merchantInfo
    } = this.props;

    const isDiscount = product.price_info && product.price_info.is_discount;

    const ifShoppingCenter = configStore.siteConfig.isShoppingCenter;
    const ifBuyingAllowed = merchantInfo && merchantInfo.buyingAllowed;

    if (ifShoppingCenter && !ifBuyingAllowed) {
      return null;
    }

    return (
      <div className="ProductPagePrice">
        {isDiscount &&
          withDiscountBalloon && (
            <div className="ProductPagePrice__balloon">
              <FormattedMessage {...globalTranslations.productOffer} />
            </div>
          )}
        {isDiscount &&
          withDiscountSavings && (
            <div className="ProductPagePrice__savings">
              {this.renderDiscountDescription()}
              <span className="ProductPagePrice__savings-amount">
                <FormattedMessage
                  {...globalTranslations.youSaveSentence}
                  values={{
                    savings: (
                      <Price price={product.price_info.getSavings(withTax)} />
                    )
                  }}
                />
              </span>
            </div>
          )}
        <div className="ProductPagePrice__price-container">
          {price}
          {isDiscount &&
            !isSecondaryPrice && (
              <DiscountSign
                percentage={product.price_info.discount_percentage}
                withLabel={withDiscountLabel}
                withUpTo={withDiscountUpTo}
                inverted={discountInverted}
                className={className}
              />
            )}
        </div>
        <ProductSingularPrice product={product} withTax={withTax} />
        {product.price_info &&
          product.price_info.valid_until_html &&
          !isSecondaryPrice && (
            <div
              className="ProductPagePrice__valid-until"
              dangerouslySetInnerHTML={{
                __html: product.price_info.valid_until_html
              }}
            />
          )}
      </div>
    );
  }
}

ProductPagePrice.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  price: PropTypes.node.isRequired,
  product: PropTypes.shape({
    price_info: modelOf(ProductPriceInfo),
    package_size: PropTypes.number,
    stock_unit: PropTypes.string,
    singular_price_unit: PropTypes.string,
    singular_price_divider: PropTypes.number
  }).isRequired,
  withDiscountLabel: PropTypes.bool,
  withDiscountUpTo: PropTypes.bool,
  withDiscountBalloon: PropTypes.bool,
  withDiscountSavings: PropTypes.bool,
  withTax: PropTypes.bool.isRequired,
  discountInverted: PropTypes.bool,
  className: PropTypes.string,
  isSecondaryPrice: PropTypes.bool,
  merchantInfo: modelOf(ProductMerchantInfo)
};

export default inject((stores, props) => ({
  configStore: stores.configStore,
  withTax: isNil(props.withTax)
    ? stores.accountStore.showPricesWithTax
    : props.withTax
}))(ProductPagePrice);



// WEBPACK FOOTER //
// ./src/components/product/ProductPagePrice/index.jsx